export const USER_ROLES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  S_ADMIN: 'ROLE_SADMIN',
  SUB_USER: 'ROLE_SUSER',
  SUB_SUPER_ADMIN: 'ROLE_SUB_SADMIN',
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const ROLE_LABELS: Record<UserRole, string> = {
  ROLE_ADMIN: 'Admin',
  ROLE_USER: 'User',
  ROLE_SADMIN: 'Super Admin',
  ROLE_SUSER: 'Sub User',
  ROLE_SUB_SADMIN: 'Sub Super Admin',
};

export const isSubOrSuperAdmin = (role: UserRole | null | undefined): boolean =>
  role === USER_ROLES.S_ADMIN || role === USER_ROLES.SUB_SUPER_ADMIN;
